import { SignatureInfo } from '../../../lib/SiteLib';
import { PersonSignatureFormValues } from './personSignatureForm.schema';

export const buildPersonSignatureContact = (values: PersonSignatureFormValues): SignatureInfo => ({
  role: values.role,
  email: values.email,
  countryCode: values.countryCode,
  phone: values.phone ? values.phone.slice(values.countryCode.length) : undefined,
});
